<template>
  <path d="M742.48,928.17c-116.63-11-221.91-49.2-314.86-117.45-185.08-135.89-286-319-297.93-549.12-3.61-69.71,43.8-136.54,109.85-161.87C274.63,86.27,337.24,109.12,349,146c17.14,53.8,28.41,109.6,39.6,165.07,2.15,10.66-5.12,25.65-12.47,35.26C363.62,362.63,348,376.72,333,391c-23.84,22.62-27.64,29.08-10.75,57.6,27.67,46.72,53.85,96,90.08,135.56C455,630.71,507.41,668.33,556,709.33c16.71,14.09,32.45,11.44,49.22-3.1,69.19-60,69.58-59.91,155.62-30.74,23.93,8.11,47,18.73,70.87,27.13,42.11,14.82,57.76,49.07,62.42,88.73,1.71,14.52-2.75,34.75-12.36,44.67a709.11,709.11,0,0,1-89.6,78C779.18,923.59,759.26,923.74,742.48,928.17Z"/>
</template>

<script>
export default {
  name: "IconPhone"
}
</script>
